// 友人赛分享
export default [
    {
        path: '/friendInvitation.html',
        name: 'friendInvitation',
        component: () => import('@/viewsSharePage/index.vue'),
        meta: {
            title: '落地页'
        },
        children: [
        ],
    },
]